import { generateBreadcrumbs } from '@/utilities/router/generate-breadcrumbs';
import { generateHeader } from '@/utilities/router/generate-header';

import sidebarItems from './sidebar';

import type { RouteRecordRaw } from '@bv/router';

const managementBreadcrumbs = generateBreadcrumbs({
  label: 'Management',
  route: { name: 'mng' },
});

const managementRoutes: RouteRecordRaw = {
  path: 'management',
  name: 'mng',
  meta: {
    sidebar: sidebarItems,
    header: generateHeader('Management'),
  },
  redirect: { name: 'mng-workspaces-list' },
  children: [
    {
      path: 'workspaces',
      meta: {
        breadcrumbs: managementBreadcrumbs({
          label: 'Workspaces',
          route: { name: 'mng-workspaces-list' },
        }),
        redirectUnauthorized: { name: 'mng-workspaces-list' },
      },
      children: [
        {
          path: '',
          name: 'mng-workspaces-list',
          component: () => import('@/components/Workspace/list/WorkspaceList.vue'),
        },
        {
          path: '',
          component: () => import('@/components/Workspace/Form.vue'),
          children: [
            {
              path: 'add',
              name: 'mng-workspaces-add',
              meta: {
                permissions: 'write-workspaces',
              },
            },
            {
              path: 'edit/:id',
              name: 'mng-workspaces-edit',
              meta: {
                permissions: 'update-workspaces',
              },
            },
          ] as RouteRecordRaw[],
        },
        {
          path: ':id',
          name: 'mng-workspaces-show',
          component: () => import('@/components/Workspace/workspace-details/index.vue'),
        },
      ],
    },
    {
      path: 'users',
      meta: {
        breadcrumbs: managementBreadcrumbs({
          label: 'Users',
          route: { name: 'mng-users-list' },
        }),
        redirectUnauthorized: { name: 'mng-users-list' },
      },
      children: [
        {
          path: '',
          name: 'mng-users-list',
          component: () => import('@/components/Users/UsersList.vue'),
        },
        {
          path: 'add',
          name: 'mng-users-add',
          component: () => import('@/components/Users/AddUser.vue'),
          meta: {
            permissions: 'write-users',
          },
        },
        {
          path: ':id',
          children: [
            {
              path: '',
              name: 'mng-users-show',
              component: () => import('@/components/Users/UserDetails.vue'),
            },
            {
              path: 'workspaces',
              component: () => import('@/components/Users/Workspace/UserWorkspace.vue'),
              meta: {
                permissions: 'update-users',
              },
              children: [
                {
                  path: 'assign',
                  name: 'mng-users-workspace-assign',
                },
                {
                  path: ':workspaceId/edit',
                  name: 'mng-users-workspace-assign-edit',
                },
              ] as RouteRecordRaw[],
            },
            {
              path: 'softphone-template/:workspaceId/edit',
              name: 'mng-users-softphone-template-edit',
              component: () => import('@/components/Users/Workspace/SoftphoneTemplate.vue'),
              meta: {
                permissions: 'update-users',
              },
            },
          ],
        },
      ],
    },
    {
      path: 'employees',
      meta: {
        breadcrumbs: managementBreadcrumbs({
          label: 'Employees',
          route: { name: 'mng-employees-list' },
        }),
        redirectUnauthorized: { name: 'mng-employees-list' },
      },
      children: [
        {
          path: '',
          name: 'mng-employees-list',
          component: () => import('@/components/Employees/List.vue'),
        },
        {
          path: '',
          component: () => import('@/components/Employees/Form.vue'),
          children: [
            {
              path: 'add',
              name: 'mng-employees-add',
              meta: {
                permissions: 'write-employees',
              },
            },
            {
              path: 'edit/:id',
              name: 'mng-employees-edit',
              meta: {
                permissions: 'update-employees',
              },
            },
          ] as RouteRecordRaw[],
        },
        {
          path: ':id',
          name: 'mng-employees-show',
          component: () => import('@/components/Employees/Details.vue'),
        },
      ],
    },
  ],
};

export default managementRoutes;
